export function searchTransactionType(transactionTypes = [], searchTerm = '') {
  let element = '';

  if (transactionTypes.length > 1) {
    element = 'buy/sell';
  } else if (transactionTypes.includes('B')) {
    element = 'buy';
  } else if (transactionTypes.includes('S')) {
    element = 'sell';
  }

  if (!element) {
    return false;
  }

  if (searchTerm !== element) {
    return false;
  }

  return true;
}
